import { render, staticRenderFns } from "./AdvertCard.vue?vue&type=template&id=29008a25&scoped=true&"
import script from "./AdvertCard.vue?vue&type=script&lang=js&"
export * from "./AdvertCard.vue?vue&type=script&lang=js&"
import style0 from "./AdvertCard.vue?vue&type=style&index=0&id=29008a25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29008a25",
  null
  
)

export default component.exports